import { Button, type ButtonProps } from '@mui/material';
import TablerIconStop from '~icons/tabler/hand-stop';
import TablerIconLoader2 from '~icons/tabler/loader-2';

export interface ChatStopButtonProps extends ButtonProps {
  /**
   * The size of the button.
   * @default 'small'
   */
  size?: ButtonProps['size'];
}

function ChatStopButton({
  size = 'small',
  variant = 'outlined',
  ...props
}: ChatStopButtonProps) {
  return (
    <Button
      {...props}
      color='neutral'
      variant={variant}
      size={size}
      endIcon={<TablerIconStop />}
      loadingIndicator={<TablerIconLoader2 className='animate-spin' />}
      loadingPosition='end'
    >
      Stop
    </Button>
  );
}

export default ChatStopButton;
